import { GET_SURVEY_VIEW_COUNT } from '../../fetchTypes';
import {
  createDefaultRequestInitialState,
  createSelectorById,
  createSelectorByIdList,
  defaultRequestByIdReducer,
} from './withFetch';

const initialState = createDefaultRequestInitialState();
export const actionDataToId = (data) => data.sid;

const reducer = defaultRequestByIdReducer({
  actionDataToId,
  resultMapper: (data) => (data || {}).viewCount,
});

export default (state = initialState, action) => {
  switch (action.fetchType) {
    case GET_SURVEY_VIEW_COUNT:
      return reducer(state, action);
    default:
      return state;
  }
};

const selfSelector = (state) => state.fetcher.surveyViewCount;
export const selectFetcherSurveyViewCount = selfSelector;
export const selectSurveyViewCountBySid = createSelectorById(selfSelector);
export const selectSurveyViewCountListBySidList =
  createSelectorByIdList(selfSelector);
